import dateUtils from '@utils/DateUtils'
import BaseModel from '@/models/base-model'
import sizeUtils from '@utils/sizeUtils'

export default class Table extends BaseModel {
  constructor (obj) {
    super(obj)
    this._downloadUrl = obj.download_url
    this._type = obj.type ? obj.type : 'None'
    this._created = obj.created_at ? dateUtils.convertUTCToLocalDateV2(obj.created_at) : undefined
    this._owner = obj.owner ? obj.owner.id : undefined
    this._workspaceId = obj.workspace_id
    this._createdBy = obj.created_by ? obj.created_by : undefined
    this._categories = obj.categories ? obj.categories : []
    this._rows = obj.rows ? obj.rows : 0
    this._size = obj.size_mb ? this.transformSize(obj.size_mb) : '0 KB'
    this._itemType = 'table'
  }

  transformSize (size) {
    if (size !== undefined && size !== null && size !== '') {
      return sizeUtils.transfSize(size)
    } else {
      return '0 KB'
    }
  }

  get downloadUrl () {
    return this._downloadUrl
  }

  get type () {
    return this._type
  }

  get createdAt () {
    return this._created
  }

  get ownerId () {
    return this._owner
  }

  get workspaceId () {
    return this._workspaceId
  }

  get createdBy () {
    return this._createdBy
  }

  get categories () {
    return this._categories
  }

  get rows () {
    return this._rows
  }

  get size () {
    return this._size
  }
}



// WEBPACK FOOTER //
// ./src/models/table/table.js